<ion-menu
  type="push"
  side="end"
  content-id="main-content"
  [swipeGesture]="false"
>
  <ion-header [translucent]="true" class="ion-no-border">
    <ion-toolbar>
      <ion-title>Kalender</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list>
      @for (resource of resources(); track resource.id) {
      <ion-item>
        <ion-checkbox
          class="py-2"
          labelPlacement="end"
          [(ngModel)]="resource.enabled"
          (ionChange)="changeCalendarResource(resource)"
          >{{ resource.name }}</ion-checkbox
        >
      </ion-item>
      }
    </ion-list>
  </ion-content>
  <ion-footer class="ion-no-border ion-padding safe-padding">
    <ion-button class="w-full" (click)="navigateToCalendarSettings()">
      Kalender Synchronisieren
    </ion-button>
  </ion-footer>
</ion-menu>

@defer (when isDesktop) {
<div
  class="h-18 w-44 hidden text-quickdrive dark:text-darkquickdrive md:block absolute left-0 -top-1 z-10"
>
  <h1 class="ml-4 mt-4 bg-transparent cursor-default">Quick Drive</h1>
</div>
}
<!-- if isDektop is true then add a margin left to the ion-tabs -->
<ion-tabs id="main-content" (ionTabsDidChange)="setCurrentTab($event)">
  <ion-tab-bar
    class="border-0 border-t-2 border-solid border-gray-100 dark:border-black"
    [ngClass]="isDesktop ? 'dark:bg-darktabs desktop-ios' : 'mobile'"
    [slot]="isDesktop ? 'top' : 'bottom'"
  >
    <ion-tab-button
      [ngClass]="isDesktop ? 'md:ml-40 dark:bg-darktabs' : ''"
      tab="tab0"
      href="/home/tab0"
    >
      @if (!isDesktop) {
      <ion-icon
        aria-hidden="true"
        [name]="currentTab() == 'tab0' ? 'car-sport' : 'car-sport-outline'"
      ></ion-icon>
      } @else {

      <ion-label>Übersicht</ion-label>

      }
    </ion-tab-button>

    <ion-tab-button
      [ngClass]="isDesktop ? 'dark:bg-darktabs' : ''"
      tab="tab1"
      href="/home/tab1"
    >
      @if (!isDesktop) {
      <ion-icon
        aria-hidden="true"
        [name]="currentTab() == 'tab1' ? 'people' : 'people-outline'"
      ></ion-icon>
      } @else {

      <ion-label>Fahrschüler</ion-label>

      }
    </ion-tab-button>

    <ion-tab-button
      [ngClass]="isDesktop ? 'dark:bg-darktabs' : ''"
      tab="tab2"
      href="/home/tab2"
    >
      @if (!isDesktop) {
      <ion-icon
        aria-hidden="true"
        [name]="currentTab() == 'tab2' ? 'calendar' : 'calendar-outline'"
      ></ion-icon>
      } @else {

      <ion-label>Kalender</ion-label>

      }
    </ion-tab-button>

    <ion-tab-button
      [ngClass]="isDesktop ? 'dark:bg-darktabs' : ''"
      tab="tab3"
      href="/home/tab3"
    >
      @if (!isDesktop) {
      <ion-icon
        aria-hidden="true"
        [name]="currentTab() == 'tab3' ? 'wallet' : 'wallet-outline'"
      ></ion-icon>
      } @else {

      <ion-label>Büro</ion-label>

      }
    </ion-tab-button>

    <ion-tab-button
      [ngClass]="isDesktop ? 'dark:bg-darktabs' : ''"
      tab="tab4"
      href="/home/tab4"
    >
      @if (!isDesktop) {
      <ion-icon
        aria-hidden="true"
        [name]="currentTab() == 'tab4' ? 'settings' : 'settings-outline'"
      ></ion-icon>
      } @else {

      <ion-label>Einstellungen</ion-label>

      }
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
